import { Component, h, Node } from "@lukekaalim/act"
import { html } from "@lukekaalim/act-web"

import classes from './index.module.css'

export const HorizontalCapsuleContainerMenu: Component<{ elements: Node[] }> = ({ elements }) => {
  return h(html.menu, { className: classes.horizontalCapsuleContainer },
    elements.map(el => h(html.li, {}, el)));
}